import React from 'react';
import { Icon } from '../../components';
import colors from '../../utils/colors';
import './style.scss';

const GroupInput = ({ label, value, min = 1, max = 16, onChange = () => {}, mobile }) => {
	const handleIncrease = () => {
		if (value < max) {
			onChange(++value);
		}
	};
	const handleDecrease = () => {
		if (value > min) {
			onChange(--value);
		}
	};

	const handleChange = (e) => {
		if (e.target.value <= max && e.target.value >= min) {
			onChange(e.target.value);
		}
	};

	return (
		<div className="group-input">
			<div className="group-input__label">{label}</div>
			<div className="group-input__input">
				<span className="group-input__button" onClick={handleDecrease}>
					<Icon
						name="minus"
						color={colors.greenDark}
						width={mobile ? 20 : 10}
						height={mobile ? 20 : 10}
					/>
				</span>
				<input
					type="text"
					className="group-input__value"
					value={value}
					min={min}
					max={max}
					onChange={handleChange}
				/>
				<span className="group-input__button" onClick={handleIncrease}>
					<Icon
						name="plus"
						color={colors.greenDark}
						width={mobile ? 20 : 10}
						height={mobile ? 20 : 10}
					/>
				</span>
			</div>
		</div>
	);
};

export default GroupInput;
